export class UrlExclusion {
  id: number;
  urlPattern: string;
}
